module.exports = __webpack_public_path__ + "img/electricity.36962c8d.jpeg";